import { SET_APP_LOADING, LOG_OUT } from "../types";

const INITIAL_STATE = {
  appLoading: false,
};

export default function applicationState(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SET_APP_LOADING:
      return {
        ...state,
        appLoading: action.data,
      };
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
